import { Box, Menu } from '@chakra-ui/react';
import type React from 'react';

type MenuRootProps = React.ComponentProps<typeof Menu.Root>;
type WithChildren<T> = T & { children?: React.ReactNode };
type BoxProps = React.ComponentProps<typeof Box>;
type MenuTriggerProps2 = WithChildren<
	React.ComponentProps<typeof Menu.Trigger>
> &
	BoxProps;
type MenuPositionerProps2 = WithChildren<
	React.ComponentProps<typeof Box> &
	React.ComponentProps<typeof Menu.Positioner>
>;
type MenuContentProps2 = WithChildren<
	React.ComponentProps<typeof Menu.Content>
> &
	BoxProps;
type MenuItemProps2 = WithChildren<React.ComponentProps<typeof Menu.Item>> &
	BoxProps & {
		disabled?: boolean;
	};
type MenuArrowProps = React.ComponentProps<typeof Menu.Arrow>;

export const MenuPrimitives = {
	Root: (props: MenuRootProps) => <Menu.Root {...props} />,
	Trigger: (props: MenuTriggerProps2) => <Box as={Menu.Trigger} {...props} />,
	Positioner: (props: MenuPositionerProps2) => <Box as={Menu.Positioner} {...props} />,
	Content: (props: MenuContentProps2) => <Box as={Menu.Content} {...props} />,
	Item: (props: MenuItemProps2) => <Box as={Menu.Item} {...props} />,
	Arrow: (props: MenuArrowProps) => <Menu.Arrow {...props} />,
};

export type {
	MenuRootProps,
	MenuTriggerProps2,
	MenuPositionerProps2,
	MenuContentProps2,
	MenuItemProps2,
	MenuArrowProps,
};
